import { ADMIN_TOKEN, storageEngine } from 'utilities/integration/rails';

// Proves to platform-core that a Wonolo admin is behind this session (Auth::WonoloAdminToken). Only the server
// can verify it, so gate admin-only UI on useWonoloAdminSession rather than on whether this is set.
export const getAdminToken = () => storageEngine.getItem(ADMIN_TOKEN);

// Signing in or out directly is never an admin's "Login as", so a token kept from one must go
export const clearAdminToken = () => storageEngine.removeItem(ADMIN_TOKEN);

// Sent only when there is a token, so requestors' requests don't carry one the server must reject
export const adminTokenHeaders = () => {
  const adminToken = getAdminToken();
  return adminToken ? { 'Wonolo-Admin-Token': adminToken } : {};
};

export default getAdminToken;
